module.exports = __webpack_public_path__ + "content/cf85274c2575127a93859238e74e3d37.png";